export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12027.4ff822a8.jpg";